<template>
  <div class="main-content-cols">
    <side-menu
      v-if="menus.length > 1"
      :menus="menus"
      :actived="actived"
      @change="deviceChange"
    ></side-menu>

    <div class="main-content-cols__body">
      <search slot="header" :device="device" @date-change="goSearch"></search>

      <el-row>
        <img-cards
          :data="data"
          :loading="loading"
          @show-model="showModel"
        ></img-cards>

        <div class="margin-t16 text-right">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="limit"
            :current-page="page"
            @current-change="goPage"
          >
          </el-pagination>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import SideMenu from '@/components/MainSideMenu'
import showImgDetail from './components/model/index'
import ImgCards from './components/cards'
import Search from './components/search'
import { getPictures } from '@/service/rodent'
import { formatDate, subtract } from '@/utlis/date'

export default {
  components: { ImgCards, Search, SideMenu },
  data() {
    return {
      query: {
        deviceId: null
      },
      loading: false,
      searchOpen: false,
      total: 0,
      limit: 21,
      page: 1,
      data: [],
      detail: null,
      actived: -1
    }
  },
  computed: {
    menus() {
      return this.rodents.map(r => ({
        title: r.name,
        subtitle: r.state === 1 ? '在线' : '离线'
      }))
    },
    device() {
      return this.rodents[this.actived]
    }
  },
  mounted() {
    this.query = {
      page: 1,
      limit: this.limit,
      companyId: this.companyId,
      beginDate: subtract(undefined, 30, 'days', 'YYYY-MM-DD 00:00:00')
    }
    if (this.rodents && this.rodents[0]) {
      this.deviceChange(0)
    }
  },
  methods: {
    async getData(query = {}) {
      try {
        this.loading = true
        const { data } = await getPictures(query)
        const { paging, data: pictures } = data
        this.total = paging.count
        this.page = paging.page
        this.data = pictures.map(p => ({
          id: p.id,
          createdAt: formatDate(p.createdAt),
          title: `${p.device} - ${p.id}`,
          src: p.coverPath,
          video: p.sourcePath
        }))
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    goSearch(beginDate, endDate) {
      this.query = { ...this.query, beginDate, endDate, page: 1 }
      this.getData(this.query)
    },
    goPage(page) {
      this.query.page = page
      this.getData(this.query)
    },
    showModel(img) {
      showImgDetail({ img, device: this.device })
    },
    deviceChange(actived) {
      this.actived = actived
      this.query = { ...this.query, page: 1, deviceId: this.device.id }
      this.getData(this.query)
    }
  },
  watch: {
    rodents(devices) {
      if (devices && devices[0]) {
        this.deviceChange(0)
      }
    }
  }
}
</script>

<style lang="scss">

</style>
